<div class="row text-center ma-font-setup">
  <div class="col">    
    <h1 class="title-copy">
      {{ "VALIDATE_WITH_EMAIL" | translate }}
    </h1>
    <p class="mb-0">
      {{ "EMAIL_IS_ASSOCIATED_WITH_YOUR_POLICY" | translate }}
    </p>
    <P class="mb-4">
      {{ "CONFIRM_EMAIL_TO_FINISH_ACCOUNT_SETUP" | translate }}
    </P>
    <div class="email-title mb-4 lh24">
      <b>{{ email }}</b>
    </div>
    <mapfre-button
      additionalClasses="basic primary large-btn margin-bottom mb24"
      (click)="sendEmail()"
    >
      {{ "CONTINUE" | translate }}
    </mapfre-button>
    <p class="email-p-tag">
      {{ "DONT_RECOGNIZE_THE_EMAIL" | translate }}
    </p>
    <ng-container *ngIf="isAcmic; else MAStateBtn">
      <mapfre-button
      (click)="validateMobile()"
      additionalClasses="mapfre link ghost blue button-border-login primary small no-margin btn"
    >
      {{ "USE_MOBILE_PHONE" | translate }}
    </mapfre-button>
    </ng-container>
    <ng-template #MAStateBtn>
      <mapfre-button
      (click)="validateMobile()"
      additionalClasses="btn ghost h40 mapfre no-margin secondary button-border-login no-margin btn"
    >
      {{ "USE_MOBILE_PHONE" | translate }}
    </mapfre-button>
    </ng-template>
  </div>
</div>
